module.exports = __webpack_public_path__ + "static/media/Aniversariantes.070f186f.png";